import { render, staticRenderFns } from "./feedFormula.vue?vue&type=template&id=766c7ee0&scoped=true&"
import script from "./feedFormula.vue?vue&type=script&lang=js&"
export * from "./feedFormula.vue?vue&type=script&lang=js&"
import style0 from "./feedFormula.vue?vue&type=style&index=0&id=766c7ee0&prod&scoped=true&lang=css&"
import style1 from "./feedFormula.vue?vue&type=style&index=1&id=766c7ee0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766c7ee0",
  null
  
)

export default component.exports